module.exports = __webpack_public_path__ + "img/2.8d1bbfc7.png";